import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const ToastCtx = createContext({ success:()=>{}, error:()=>{} });
export const useToast = () => useContext(ToastCtx);

export function ToastProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [sev, setSev] = useState('info');

  const show = useCallback((severity, text) => {
    setSev(severity); setMsg(text); setOpen(true);
  }, []);
  const success = useCallback((t)=>show('success', t), [show]);
  const error = useCallback((t)=>show('error', t), [show]);

  // Global event bridge: window.dispatchEvent(new CustomEvent('hrapp.toast', { detail:{ sev:'error', msg:'...' } }))
  useEffect(() => {
    const handler = (e) => {
      const d = e?.detail || {}; const s = d.sev || 'info'; const m = d.msg || '';
      if (m) show(s, m);
    };
    window.addEventListener('hrapp.toast', handler);
    return () => window.removeEventListener('hrapp.toast', handler);
  }, [show]);

  return (
    <ToastCtx.Provider value={{ success, error }}>
      {children}
      <Snackbar open={open} autoHideDuration={3000} onClose={()=>setOpen(false)} anchorOrigin={{ vertical:'bottom', horizontal:'right' }}>
        <Alert onClose={()=>setOpen(false)} severity={sev} sx={{ width:'100%' }}>{msg}</Alert>
      </Snackbar>
    </ToastCtx.Provider>
  );
}

